/* eslint-disable max-lines */
import "../components/commonStyles/globalStyles.css";

import { PartnerRouteConfig, UhfFooterMode, UhfHeaderMode } from "@gamedev-web/gamedev-sdk-core";

import { AaaDashboardPage } from "../pages/AaaDashboardPage";
import { AaaGameInformationPage } from "../pages/AaaGameInformationPage";
import { AaaWelcomePartnerPage } from "../pages/AaaWelcomePartnerPage";
import AaaFormPreviewPage from "../pages/FormPreview/AaaFormPreview";
import PitchFormPreviewPage from "../pages/FormPreview/PitchFormPreview";
import { GameInformationPage } from "../pages/GameInformationPage";
import { IdXboxGameInfoDashboard } from "../pages/IdXboxGameInfoDashboard";
import { IdXboxIntroPage } from "../pages/IdXboxIntroPage";
import {
  IdXboxWelcomePartnerFormPreview,
  IdXboxWelcomePartnerPage,
} from "../pages/IdXboxWelcomePartnerPage";
import { LandingPage } from "../pages/LandingPage";
import PitchHomePage from "../pages/PitchHomePage/PitchHomePage";
import PitchInformationPage from "../pages/PitchInformationPage/PitchInformationPage";
import { PitchWelcomePartnerPage } from "../pages/PitchWelcomePartnerPage";
import { ProgramSelectionPage } from "../pages/ProgramSelectionPage";
import StreamingEuEmailVerifyPage from "../pages/StreamingEuPage/StreamingEuEmailVerifyPage";
import StreamingEuPage from "../pages/StreamingEuPage/StreamingEuPage";
import TestConsolePage from "../pages/TestConsolePage/TestConsolePage";
import GdkMiddlewareRequestPage from "../pages/GdkMiddlewareRequestPage/GdkMiddlewareRequestPage";
import { RouteNames } from "./routeNames";

export enum Paths {
  IntroInfo = "intro-info",
  ApplicationIdPlaceholder = ":applicationId",
  PageIdPlaceholder = ":pageId",
}

const routeGameDevBase = "/games";
const routeBase = `${routeGameDevBase}/publish`;
export const OnboardingUrls = {
  [RouteNames.AaaDashboard]: `${routeBase}/xbox`,
  [RouteNames.AaaWelcome]: `${routeBase}/xbox/welcome`,
  [RouteNames.AaaGameInformation]: `${routeBase}/xbox/game-information/${Paths.PageIdPlaceholder}`,
  [RouteNames.AaaFormPreview]: `${routeBase}/xbox/form-preview`,
  [RouteNames.GdkMiddlewareRequest]: `${routeGameDevBase}/support/request-gdkx-middleware`,
  [RouteNames.IdXboxGameInfoDashboard]: `${routeBase}/id`,
  [RouteNames.IdXboxIntro]: `${routeBase}/id/introduction/${Paths.PageIdPlaceholder}`,
  [RouteNames.IdXboxGameInfoForm]: `${routeBase}/id/game-information/${Paths.PageIdPlaceholder}`,
  [RouteNames.IdXboxWelcome]: `${routeBase}/id/welcome`,
  [RouteNames.IdXboxFormPreview]: `${routeBase}/id/form-preview`,
  [RouteNames.Landing]: routeBase,
  [RouteNames.PitchHome]: `${routeBase}/pitch`,
  [RouteNames.PitchWelcome]: `${routeBase}/pitch/welcome`,
  [RouteNames.PitchIntro]: `${routeBase}/pitch/introduction/${Paths.PageIdPlaceholder}`,
  [RouteNames.PitchInformation]: `${routeBase}/pitch/pitch-information/${Paths.PageIdPlaceholder}`,
  [RouteNames.PitchFormPreview]: `${routeBase}/pitch/form-preview`,
  [RouteNames.ProgramSelection]: `${routeBase}/program-selection`,
  [RouteNames.StreamingEu]: `${routeBase}/activision-blizzard-cloud-game-streaming-eu/streaming-provider-registration`,
  [RouteNames.StreamingEuEmailVerify]: `${routeBase}/activision-blizzard-cloud-game-streaming-eu/email-verification`,
  [RouteNames.TestConsole]: `${routeBase}/testconsole`,
};

export const routes: PartnerRouteConfig[] = [
  {
    key: RouteNames.Landing,
    path: OnboardingUrls[RouteNames.Landing],
    component: LandingPage,
    exact: true,
  },
  {
    key: RouteNames.ProgramSelection,
    path: OnboardingUrls[RouteNames.ProgramSelection],
    component: ProgramSelectionPage,
    exact: true,
  },
  {
    key: RouteNames.IdXboxGameInfoDashboard,
    path: OnboardingUrls[RouteNames.IdXboxGameInfoDashboard],
    component: IdXboxGameInfoDashboard,
    exact: true,
  },
  {
    key: RouteNames.IdXboxIntro,
    path: OnboardingUrls[RouteNames.IdXboxIntro],
    component: IdXboxIntroPage,
    exact: true,
  },
  {
    key: RouteNames.IdXboxGameInfoForm,
    path: OnboardingUrls[RouteNames.IdXboxGameInfoForm],
    component: GameInformationPage,
    exact: true,
  },
  {
    key: RouteNames.IdXboxWelcome,
    path: OnboardingUrls[RouteNames.IdXboxWelcome],
    component: IdXboxWelcomePartnerPage,
    exact: true,
  },
  {
    key: RouteNames.IdXboxFormPreview,
    path: OnboardingUrls[RouteNames.IdXboxFormPreview],
    component: IdXboxWelcomePartnerFormPreview,
    exact: true,
  },
  {
    key: RouteNames.TestConsole,
    path: OnboardingUrls[RouteNames.TestConsole],
    component: TestConsolePage,
    exact: true,
    constraint: {
      featureGates: { ["enabletestconsole"]: value => value === true },
    },
    uhfConfig: {
      headerMode: UhfHeaderMode.None,
      footerMode: UhfFooterMode.None,
    },
  },
  {
    key: RouteNames.PitchHome,
    path: OnboardingUrls[RouteNames.PitchHome],
    component: PitchHomePage,
    exact: true,
  },
  {
    key: RouteNames.PitchInformation,
    path: OnboardingUrls[RouteNames.PitchInformation],
    component: PitchInformationPage,
    exact: true,
  },
  {
    key: RouteNames.PitchWelcome,
    path: OnboardingUrls[RouteNames.PitchWelcome],
    component: PitchWelcomePartnerPage,
    exact: true,
  },
  {
    key: RouteNames.PitchFormPreview,
    path: OnboardingUrls[RouteNames.PitchFormPreview],
    component: PitchFormPreviewPage,
    exact: true,
  },
  {
    key: RouteNames.AaaWelcome,
    path: OnboardingUrls[RouteNames.AaaWelcome],
    component: AaaWelcomePartnerPage,
    exact: true,
  },
  {
    key: RouteNames.AaaDashboard,
    path: OnboardingUrls[RouteNames.AaaDashboard],
    component: AaaDashboardPage,
    exact: true,
  },
  {
    key: RouteNames.AaaGameInformation,
    path: OnboardingUrls[RouteNames.AaaGameInformation],
    component: AaaGameInformationPage,
    exact: true,
  },
  {
    key: RouteNames.AaaFormPreview,
    path: OnboardingUrls[RouteNames.AaaFormPreview],
    component: AaaFormPreviewPage,
    exact: true,
  },
  {
    key: RouteNames.StreamingEu,
    path: OnboardingUrls[RouteNames.StreamingEu],
    component: StreamingEuPage,
    exact: true,
  },
  {
    key: RouteNames.StreamingEuEmailVerify,
    path: OnboardingUrls[RouteNames.StreamingEuEmailVerify],
    component: StreamingEuEmailVerifyPage,
    exact: true,
  },
  {
    key: RouteNames.GdkMiddlewareRequest,
    path: OnboardingUrls[RouteNames.GdkMiddlewareRequest],
    component: GdkMiddlewareRequestPage,
    exact: true,
  },
];
